export default __webpack_public_path__ + "static/FDIC_Member-2c7af1411c6d6ee284f0c06e10d685ea.png";